/**
 * ScrollToTop — resets window scroll to (0,0) on every route change.
 * SPA navigation otherwise preserves the previous page's scroll
 * position, which is jarring when jumping from a long page (e.g.
 * landing) to a new one (e.g. /california/los-angeles-adu-permit).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Defer to next tick so the new page mounts before we scroll.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
